import React, { FC } from 'react';
import { Box, Text } from '@wix/design-system';
import { useAtom } from 'jotai';
import { CardLayout } from '../../../../../../components/layouts/CardLayout';
import s from './SideContent.scss';
import { ProductGrid } from '../ProductGrid/ProductGrid';
import { useImageLoader } from '../../hooks/useImageLoader';
import { activeImagesAtom, enabledImagesAtom } from '../../context/loadingProgress';
import { useTranslation } from '@wix/wix-i18n-config';

interface Props {
  products: { image: string; name: string }[];
}

export const SideContent: FC<Props> = ({ products }) => {
  const { t } = useTranslation();
  const [activeImages] = useAtom(activeImagesAtom);
  const [enabledImages] = useAtom(enabledImagesAtom);

  const { loadedImages, handleImageLoad, displayProducts } = useImageLoader({
    products,
    maxDisplayProducts: 6,
  });

  return (
    <CardLayout>
      <Box direction="vertical" gap={2}>
        <Box direction="vertical" gap={1}>
          <Text weight="bold">{t('product_loading_grid.side_content.header')}</Text>

          <Text weight="thin">{t('product_loading_grid.side_content.subtitle')}</Text>
        </Box>

        <Box className={s.gridContainer} width="100%">
          <ProductGrid
            products={displayProducts}
            loadedImages={loadedImages}
            activeImages={activeImages}
            enabledImages={enabledImages}
            onImageLoad={handleImageLoad}
          />
        </Box>
      </Box>
    </CardLayout>
  );
};
